module.exports = __webpack_public_path__ + "static/media/image8.eef9b7d5.jpg";